/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Button, Form, Input, Message } from 'semantic-ui-react';

import '../../css/UpdateUserPasswordModal.less';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import Modal from '../Modal';

export default
@inject('userManager')
@observer
class UpdateUserPasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidePasswordError: true,
      newPassword: '',
      passwordInputType: 'password',
      serverErrorMsg: ''
    };
    this.ShowPasswordButton = SatCoreComponent('ShowPasswordButton');
  }

  onChangePassword = async () => {
    const { close, save, t } = this.props;
    const { newPassword } = this.state;
    if (!this.validate()) {
      return;
    }
    try {
      await save(newPassword);
      close();
    } catch (error) {
      this.setState({ serverErrorMsg: t('defaultChangePasswordServerErrorMsg') });
    }
  }

  validate = () => {
    const { newPassword } = this.state;
    if (!/^.{8,}$/.test(newPassword) || !/^\s*\S.*$/.test(newPassword)) {
      this.setState({ hidePasswordError: false });
      return false;
    }
    return true;
  }

  onChangePasswordInput = (e) => {
    const { value } = e.target;
    this.setState((prevState) => ({ ...prevState, newPassword: value }));
  }

  clearError = () => {
    this.setState({
      hidePasswordError: true,
      serverErrorMsg: ''
    });
  }

  makeAccessCode = async () => {
    const { userManager } = this.props;
    const code = await userManager.getTempStudentCode();
    this.setState({ newPassword: code, passwordInputType: 'text' });
  }

  render() {
    const { close, open, t, userName } = this.props;
    const { hidePasswordError, newPassword, passwordInputType, serverErrorMsg } = this.state;
    const { ShowPasswordButton } = this;

    return (
      <Modal
        className='updateUserPasswordModal'
        closeOnDimmerClick={false}
        closeOnEscape={true}
        onClose={close}
        open={open}>
        <Modal.Header>Reset Password</Modal.Header>
        <Modal.Content>
          <p className='studentName'>{userName}</p>
          <Form.Field>
            <Input
              label={(
                <>
                  <ShowPasswordButton
                    isPassword={passwordInputType === 'password'}
                    name='passwordInputType'
                    onFlip={(name, isPassword) => this.setState({ [name]: isPassword ? 'password' : 'text' })} />
                  <a onClick={this.makeAccessCode}>Refresh</a>
                </>
              )}
              labelPosition='right'
              name='password'
              onChange={this.onChangePasswordInput}
              onFocus={this.clearError}
              onKeyPress={(e) => e.stopPropagation()}
              placeholder={t('passwordPlaceholder')}
              type={passwordInputType}
              value={newPassword} />
            <Message
              content={t('invalidPasswordMsg')}
              error
              hidden={hidePasswordError} />
            {!!serverErrorMsg && (
              <Message
                content={serverErrorMsg}
                error />
            )}
          </Form.Field>
        </Modal.Content>
        <Modal.Actions>
          <Button basic className='cancelButton'
            onClick={close} primary>{t('cancel')}
          </Button>
          <Button
            basic className='saveButton' disabled={!hidePasswordError || serverErrorMsg}
            onClick={this.onChangePassword} primary>{t('save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

SatCoreRegister('UpdateUserPasswordModal', UpdateUserPasswordModal);
